// extracted by mini-css-extract-plugin
module.exports = {"page-not-found":"not-found_page-not-found__Zeatx","not-found-icon":"not-found_not-found-icon__D8RYH","title":"not-found_title__zCSFd","sub-title":"not-found_sub-title__LsJ46"};